import {ChangeDetectorRef, Injectable} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ReplaySubject} from 'rxjs';
import {SnackBarDataModel} from '../models/snack-bar-model';

declare let $: any;

@Injectable()
export class ModalService {
    bsModalRef: BsModalRef;
    changeDetectorRef: ChangeDetectorRef;

    private $snackBar = new ReplaySubject<SnackBarDataModel>(1);
    public snackBar = this.$snackBar.asObservable();

    constructor(private modalService: BsModalService) {
    }

    openModalWithComponent(modalComponent: any, config: any) {
        this.bsModalRef = this.modalService.show(modalComponent, Object.assign({backdrop: 'static'}, config));
        //Need this to remove role document on all Modals as it mesees with Screen readers
        let hostElement = this.bsModalRef.content.hostElement;
        hostElement?.nativeElement?.parentElement?.parentElement?.removeAttribute('role');
        return this.bsModalRef;
    }

    public setSnackBar = (data: SnackBarDataModel) => {
        this.$snackBar.next(data);
    }

    public removeMobileFocusLoop = (): void => {
        const elsToReset = document.querySelectorAll('[data-old-aria-hidden]');

        for (let i = 0; i < elsToReset.length; i++) {
            const el = elsToReset[i];
            const ariaHiddenVal = el.getAttribute('data-old-aria-hidden');
            if (ariaHiddenVal === 'null') {
                el.removeAttribute('aria-hidden');
            } else {
                el.setAttribute('aria-hidden', ariaHiddenVal);
            }
            el.removeAttribute('data-old-aria-hidden');
        }
    }

    public setMobileFocusLoop = (el: HTMLElement): void => {
        const {body} = document;
        let currentEl = el;
        do {
            const siblings = currentEl.parentElement.children;
            for (let i = 0; i < siblings.length; i++) {
                const sibling = siblings[i];
                if (sibling !== currentEl && sibling.setAttribute && sibling.nodeName !== 'SCRIPT' && sibling.nodeName !== 'STYLE') {
                    sibling.setAttribute('data-old-aria-hidden', sibling.getAttribute('aria-hidden') || 'null');
                    sibling.setAttribute('aria-hidden', 'true');
                }
            }
            //  set the currentEl to be the parent node
            // and repeat (unless the currentNode is the body tag).
            currentEl = currentEl.parentElement;
        } while (currentEl !== body);
    }

    public modalFocusTrap(modalEl) {
        const focusableElements =
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const modal = $(modalEl);

        const focusableContent = modal.find(focusableElements);
        const firstFocusableElement = focusableContent.first()[0];
        const lastFocusableElement = focusableContent.last()[0];


        document.addEventListener('keydown', function (e) {
            let isTabPressed = e.key === 'Tab';

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        });

        firstFocusableElement.focus();
    }
}
